// moviesSlice.js
import {createSlice} from "@reduxjs/toolkit";

const moviesSlice = createSlice({
    name: "movies",
    initialState: {
        nowPlayingMovies: {movies: null},
        trailerVideo: {movies: null},
        popularMovies: {movies: null},
        topRatedMovies: {movies: null},
        upcomingMovies: {movies: null},



    },
    reducers: {
        addNowPlayingMovies: (state, action) => {
            state.nowPlayingMovies = action.payload;
        },
        addTrailerVideo: (state, action) => {
            state.trailerVideo = action.payload;
        },
        addPopularMovies: (state, action) => {
            state.popularMovies = action.payload;
        },
        addTopRatedMovies: (state, action) => {
            state.topRatedMovies = action.payload;
        },
        addUpcomingMovies: (state, action) => {
            state.upcomingMovies = action.payload;
        },


    },
});

export const {
    addNowPlayingMovies,
    addTrailerVideo,
    addPopularMovies,
    addUpcomingMovies,
    addTopRatedMovies,


} = moviesSlice.actions;
export default moviesSlice.reducer;
